import React, {useEffect, useState} from "react";
import {Button, Col, FormControl, FormGroup, InputGroup, Row} from "react-bootstrap";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import * as Actions from './AchApi'
import {useMediaQuery} from '../../../../utilities/hooks/useMediaQuery';

const Ach = ({total, setACHCharge, invoiceToken, actions}) => {
    const minimumPayment = 0.5
    const isMobile = useMediaQuery(991);
    const [isPaymentLoading, setIsPaymentLoading] = useState(false)
    const [payPartial, setPayPartial] = useState(false)
    const [partialAmount, setPartialAmount] = useState('0.00')
    const [acceptedPartialValue, setAcceptedPartialValue] = useState('')

    useEffect(() => {
        setACHCharge(payPartial ? acceptedPartialValue : total)
    }, [acceptedPartialValue, payPartial]);

    useEffect(() => {
        const stopLoading = () => setIsPaymentLoading(false)
        window.addEventListener('pageshow', stopLoading)
        return () => window.removeEventListener('pageshow', stopLoading)
    }, []);

    const calculateACHValue = (amount) => {
        if (amount) {
            let basedAmount = parseFloat(amount)
            let totalACHAmount = basedAmount / (1 - 0.008)

            if (basedAmount > 625) {
                return (basedAmount + 5).toFixed(2)
            } else {
                return (basedAmount + (totalACHAmount - basedAmount)).toFixed(2)
            }
        }
    }

    const isPartialAmountValid = partialAmount >= minimumPayment && partialAmount <= total
    const amount = payPartial ? acceptedPartialValue : total
    const isPaymentAmountValid = amount >= minimumPayment
    const paymentButtonText = payPartial && !acceptedPartialValue ? 'Pay' : `Pay $${calculateACHValue(amount)}`

    const formatPartialAmount = () => {
        const amount = parseFloat(partialAmount)
        if (!Number.isNaN(amount)) setPartialAmount(amount.toFixed(2))
    }

    const handleAchPay = () => {
        if (!isPaymentAmountValid) return

        setIsPaymentLoading(true)
        actions.achCheckout(invoiceToken, amount, (res) => {
            localStorage.setItem('ach_payment', "true")
            window.location.href = res.checkout_url
        }).catch(() => setIsPaymentLoading(false))
    }

    return (
        <Row className={`d-flex no-left-margin mt-15 ${isMobile && 'columnDirection'}`}>
            <Col xs={isMobile ? 7 : 4}>
                <Row>
                    <Button disabled={isPaymentLoading || !isPaymentAmountValid} className="no-border-radius"
                            onClick={() => handleAchPay()}>{isPaymentLoading ? "...Loading" : paymentButtonText}</Button>
                    <Button onClick={() => setPayPartial(!payPartial)}
                            className="no-border-radius">Pay
                        partial</Button>
                </Row>
            </Col>
            {payPartial ?
                <Col xs={5} className={isMobile && 'mt-15 width-80 no-left-padding'}>
                    <FormGroup className='d-flex bottom0'>
                        <InputGroup>
                            <InputGroup.Addon>$</InputGroup.Addon>
                            <FormControl type="text" value={partialAmount}
                                         onBlur={formatPartialAmount}
                                         onChange={e => {
                                             const value = e.target.value.replace(/[^0-9.]/g, '')
                                             const partialValue = value.match(/^\d*\.?\d{0,2}/)?.[0] || ''

                                             setAcceptedPartialValue('')

                                             if (partialValue > total) {
                                                 setPartialAmount(total)
                                             } else {
                                                 setPartialAmount(partialValue)
                                             }
                                         }}
                                         className="border_none"
                            />
                        </InputGroup>
                        <button disabled={!isPartialAmountValid} className="border_none" onClick={() => {
                            const amount = parseFloat(partialAmount).toFixed(2)
                            setPartialAmount(amount)
                            setAcceptedPartialValue(amount)
                        }}>Accept
                            Amount
                        </button>
                    </FormGroup>
                    {partialAmount > 0 && !isPartialAmountValid &&
                        <small className="text-danger">Minimum payment amount is $0.50.</small>}
                </Col>
                : null}
        </Row>
    )
}

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(Actions, dispatch)
});

export default connect(null, mapDispatchToProps)(Ach)
